import request from '@/utils/request'

export function findSalesQuoteCatalog() {
  return request({
    url: '/sales_quotes/catalog',
    method: 'get'
  })
}

export function findSalesQuotes(params) {
  return request({
    url: '/sales_quotes',
    method: 'get',
    params
  })
}

export function findSalesQuote(id) {
  return request({
    url: `/sales_quotes/${id}`,
    method: 'get'
  })
}

export function createSalesQuote(data) {
  return request({
    url: '/sales_quotes',
    method: 'post',
    data
  })
}

export function updateSalesQuote(id, data) {
  return request({
    url: `/sales_quotes/${id}`,
    method: 'put',
    data
  })
}

export function downloadSalesQuoteFile(id) {
  return request({
    url: `/sales_quotes/${id}/file`,
    method: 'get',
    responseType: 'blob'
  })
}

export function downloadDraftSalesQuoteFile(data) {
  return request({
    url: '/sales_quotes/file',
    method: 'post',
    data,
    responseType: 'blob'
  })
}
